export const Routing = {
  user: '/api/user.json?programs=1',
  login: '/login'
};

export const Button = {
  Variant: {
    primary: 'primary',
    primaryAlt: 'primary-alt',
    secondary: 'secondary',
  },
  Size: {
    small: 'small',
    medium: 'medium',
  },
  State: {
    unknown: 'unknown',
    loggedOut: 'logged.out', // Default, fallback
    loggedInMember: 'logged_in.member',
    loggedInNonMember: 'logged_in.non_member',
  }
}

export function classNames(variant, size) {
  const StyleMap = {
    [Button.Variant.primary]: {
      [Button.Size.small]: 'nv-cta-primary nv-cta-primary--small',
      [Button.Size.medium]: 'nv-cta-primary',
    },
    [Button.Variant.primaryAlt]: {
      [Button.Size.small]: 'nv-cta-primary-alt nv-cta-primary-alt--small',
      [Button.Size.medium]: 'nv-cta-primary-alt',
    },
    [Button.Variant.secondary]: {
      [Button.Size.small]: 'nv-cta-secondary nv-cta-secondary--small',
      [Button.Size.medium]: 'nv-cta-secondary',
    },
  };

  return StyleMap[variant]?.[size] || 'nv-cta-primary nv-cta-primary--small';
}

export function target(value = false) {
  return value ? '_blank' : null;
}

export function safeValue(value, defaultValue) {
  if (value === null || value === undefined) return defaultValue;
  if (typeof value === "number" && Number.isNaN(value)) return defaultValue;
  if (typeof value === "string" && value.trim() === "") return defaultValue;

  return value;
}
